import { render, staticRenderFns } from "./yes-no.vue?vue&type=template&id=81def46a&scoped=true&"
import script from "./yes-no.vue?vue&type=script&lang=js&"
export * from "./yes-no.vue?vue&type=script&lang=js&"
import style0 from "./yes-no.vue?vue&type=style&index=0&id=81def46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81def46a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
